export class Brod2SodaTasteValueConverter {
  static x = {
    COLA: 'Colasmak',
    OTHER: 'Andre smaker',
    MIXER: 'Mixere',
  };

  toView(value) {
    return Brod2SodaTasteValueConverter.toView(value);
  }

  static toView(value) {
    return this.x[value];
  }
}
